import { User } from '../../models/context.model';
import { IAvatarFactory } from './avatar-factory.interface';

export class UserAvatarFactory implements IAvatarFactory {
	constructor(private user: User) {}

	public getRandomColor(colors: string[]): string {
		return colors[(this.user.Id || this.user.IdCompany || 0) % colors.length];
	}

	public getLetter(): string {
		let letter = '*';

		if (this.user.FirstName && this.user.FirstName.trim().length) {
			letter = this.user.FirstName.trim()[0];
		} else if (this.user.LastName && this.user.LastName.trim().length) {
			letter = this.user.LastName.trim()[0];
		} else if (this.user.CurrentCompany && this.user.CurrentCompany.Name?.trim().length) {
			letter = this.user.CurrentCompany.Name.trim()[0];
		}

		return letter.toUpperCase();
	}
	public getImagePath(): string {
		if (this.user.ImgPath) {
			if (this.user.ImgPath.split('?')[1]) {
				return this.user.ImgPath.split('?')[0].replace('.jpg', '.JPG');
			} else {
				return this.user.ImgPath;
			}
		} else {
			return '';
		}
	}
}
